import { render, staticRenderFns } from "./ThankYouInfoSelector.vue?vue&type=template&id=db04db54&"
import script from "./ThankYouInfoSelector.vue?vue&type=script&lang=ts&"
export * from "./ThankYouInfoSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports